
































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { ClientsidePaymentMethod, ClientsidePaymentMethodType } from '@/models/payment/PaymentMethods'
import CenteredSpinner from '@/components/CenteredSpinner.vue'
import PaymentMethodRow from './Manager/PaymentMethodRow.vue'
import BraintreeDropin from 'braintree-web-drop-in'
import DropinContainer from './DropinContainer.vue'

@Component(
    {
        refs: ['dropinContainer'],
        components: {
            CenteredSpinner,
            PaymentMethodRow,
            DropinContainer
        },
        recomputed: {
            paymentMethodReady()
            {
                let _this = this as PaymentMethodManager;
                if (_this.dropin)
                {
                    return _this.dropin.isPaymentMethodRequestable();
                }
                return false;
            }
        }
    }
)
export default class PaymentMethodManager extends Vue
{
    @Prop(Boolean) readonly project! : Boolean; // default false
    @Prop(String) readonly pid! : String;
    @Prop(Boolean) readonly doesNotOwnSubscription! : Boolean; // default false
    @Prop(String) readonly planId! : String;

    methods : ClientsidePaymentMethod[] = []
    loading = false
    errors : { message : string }[] = []
    addingPaymentMethod = false

    get dropinContainer() : DropinContainer | null
    {
        if (!this.$refs.dropinContainer) return null;
        return this.$refs.dropinContainer as (DropinContainer);
    }

    get dropin() : BraintreeDropin.Dropin | null | undefined
    {
        if (!this.dropinContainer) return null;
        return this.dropinContainer.dropin;
    }

    onMethodChange(valid : boolean)
    {
        this.$recompute('paymentMethodReady');
    }

    async addPaymentMethod()
    {
        let dropin = this.dropin;
        if (!dropin)
        {
            return;
        }

        if (dropin.isPaymentMethodRequestable())
        {
            let method = await dropin.requestPaymentMethod();
            if (method == null)
            {
                return;
            }
            
            try
            {
                this.loading = true;
                const resp = await this.$http.post('payments/customer/methods', {nonce: method.nonce});
                this.addingPaymentMethod = false;
                await this.refresh();
            }
            catch(er)
            {
                this.loading = false;
                console.error(er);
                alert('Failed to add payment method. Make sure all information is correct.');

                let resetPaymentInfo = ()=>{
                    console.log('resetPaymentInfo...');
                    
                    if (!this)
                    {
                        console.log('!this, breaking...');
                        return;
                    }

                    console.log('this');

                    if (this.loading) return;
                    console.log('!this.loading');

                    if (!this.addingPaymentMethod) return;
                    console.log('this.addingPaymentMethod');

                    let dropin = this.dropin;
                    if (!dropin)
                    {
                        console.log('trying again');
                        this.$nextTick(resetPaymentInfo);
                        return;
                    }
                    
                    // Yay using undocumented private functions!
                    let dropinModel = (dropin as any)._model;
                    dropin.clearSelectedPaymentMethod();
                    console.log(Object.assign({}, dropin));
                }
                this.$nextTick(resetPaymentInfo);
                return;
            }
        }
    }

    async refresh()
    {
        this.errors.length = 0;
        this.methods.length = 0;
        this.loading = true;
        this.$emit('method-update');
        try
        {
            const resp = (this.project)
                ? await this.$http.get<{ methods : ClientsidePaymentMethod [] }>(`payments/customer/methods/${this.pid}`)
                : await this.$http.get<{ methods : ClientsidePaymentMethod [] }>('payments/customer/methods');
            for (let method of resp.data.methods)
            {
                this.methods.push(Object.assign(new ClientsidePaymentMethod, method));
            }
            this.methods.sort((a,b)=>{
                if (a.activeSubCard && !b.activeSubCard)
                {
                    return -1;
                }
                if (b.activeSubCard && !a.activeSubCard)
                {
                    return 1;
                }
                return 0;
            })
        }
        catch(er)
        {
            if (er.response && er.response.data && er.response.data.message)
            {
                this.errors.push({message: er.response.data.message})
            }
            console.error(er);
        }
        this.loading = false;
    }

    mounted()
    {
        this.refresh();
    }
};
